//export const rutaBase    = 'https://dev-ayuda.inverluz.cl/backend/index.php'; // DESARROLLO
export const rutaBase      = 'https://ayuda.inverluz.cl/backend/index.php'; // PRODUCCION

export default rutaBase;
export const versionAndroid = 14; // Version actual de la app Android

